// extracted by mini-css-extract-plugin
export default {"rightColumn":"MainLayout_rightColumn__DATz2","mainContent":"MainLayout_mainContent__-FXwZ","sideMenu":"MainLayout_sideMenu__AFcKZ"};